import { isly } from "isly";
import { Date } from "../Date";
import { Time } from "../Time";
import { TimeZone } from "../TimeZone";
export var Numeric;
(function (Numeric) {
    var _a;
    _a = isly
        .union(Date.Numeric.type, Time.Numeric.type, isly.object({ zone: TimeZone.Offset.type.optional() }))
        .rename("isoly.DateTime.Numeric")
        .bind(), Numeric.type = _a.type, Numeric.is = _a.is, Numeric.flawed = _a.flawed;
    function parse(value) {
        const [date, splitted] = value.split("T", 2);
        const [time, zone] = splitted?.split(/(Z|[+-].{5})?$/, 2) ?? [];
        return {
            ...(date ? Date.Numeric.parse(date) : {}),
            ...(time ? Time.Numeric.parse(time) : {}),
            ...(zone ? { zone: TimeZone.Offset.parse(zone) } : {}),
        };
    }
    Numeric.parse = parse;
    function format(value, precision) {
        const time = Time.Numeric.normalize(value);
        const days = time.hours == undefined ? undefined : Math.trunc(time.hours / 24);
        const result = {
            ...value,
            ...time,
            ...(time.hours != undefined ? { hours: time.hours % 24 } : {}),
            ...(days || value.days != undefined ? { days: days ? (value.days ?? 0) + days : value.days } : {}),
        };
        return `${Date.Numeric.format(result)}T${Time.Numeric.format(result, precision)}${result.zone ?? ""}`;
    }
    Numeric.format = format;
})(Numeric || (Numeric = {}));
//# sourceMappingURL=Numeric.js.map